import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './PaymentFailed.css';

export default function PaymentFailed() {
  const [searchParams] = useSearchParams();
  const errorMsg = searchParams.get('message') || 'The transaction was cancelled or could not be processed.';
  const orderUuid = searchParams.get('order_uuid');

  return (
    <div className="payment-failed-container section-padding">
      <div className="failed-card">
        <div className="failed-icon">✕</div>
        <h1 className="failed-title">Payment Unsuccessful</h1>
        <p className="failed-subtitle">Something went wrong during the checkout process.</p>
        
        <div className="failed-details">
          <p className="error-message">The transaction was interrupted or could not be completed at this time.</p>
          {orderUuid && (
            <p className="order-reference">
              Transaction Reference: <strong>{orderUuid}</strong>
            </p>
          )}
        </div>

        <div className="failed-actions">
          <Link to="/checkout" className="retry-btn">
            Try Again
          </Link>
          <Link to="/" className="home-btn">
            Return to Home
          </Link>
        </div>
        
        <div className="support-info">
          <p>Need help? <Link to="/contact">Contact our support team</Link></p>
        </div>
      </div>
    </div>
  );
}



